type SkeletonTableLoadProps = {
    rowCount    : number,
    columnCount : number,
    striped     : boolean
}

const SkeletonTableLoad = ({ rowCount, columnCount, striped }: SkeletonTableLoadProps) => { 

    /* JSX Element to render in Browser */
    return (
        <>
            <table className={striped ? "table table-striped" : "table"}>
                <thead>
                    <tr>
                        {
                            Array.from(Array(columnCount).keys()).map(x => {
                                return (
                                    <th scope="col" className="placeholder-glow" key={"th_" + x} >
                                        <span className="placeholder w-100"></span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        Array.from(Array(rowCount).keys()).map(x => {
                            return (
                                <tr key={"row_" + x}>
                                    {
                                        Array.from(Array(columnCount).keys()).map(y => {
                                            return (
                                                <td className="placeholder-glow" key={"cell[" + x + "," + y + "]"}>
                                                    <span className="placeholder w-100"></span>
                                                </td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>   
    )
}

export default SkeletonTableLoad;